import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import FhirImage from "../../assets/images/fhir.png";

const Sidebar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="col-md-2 side-ox-row">
      <div className="sidebar-box mb-2">
        <div className="side-bar-bx">
          <ul>
            <li className="sidebar-heading">
              <img src={FhirImage} alt="FHIR configuration" /> Transformation
            </li>
            <li>
              <Link
                to="/data-migration"
                className={
                  location.pathname === "/#"
                    ? "active-link"
                    : ""
                }
              >
                <i className="fa fa-angle-right"></i> Customer Details
              </Link>
            </li>
            <li>
              <Link
                to="/data-migration"
                className={
                  location.pathname === "/#" 
                    ? "active-link"
                    : ""
                }
              >
                <i className="fa fa-angle-right"></i> Data System
              </Link>
            </li>
            <li>
              <Link
                to="/data-migration"
                className={
                  location.pathname === "/#"
                    ? "active-link"
                    : ""
                }
              >
                <i className="fa fa-angle-right"></i> Data Type
              </Link>
            </li>
            <li>
              <Link
                to="/data-migration"
                className={
                  location.pathname === "/#" ? "active-link" : ""
                }
              >
                <i className="fa fa-angle-right"></i> Data Format
              </Link>
            </li>
          </ul>

          <ul>
            <li className="sidebar-heading">
              <img src={FhirImage} alt="FHIR configuration" /> EHRs
            </li>
            <li>
              <Link
                to="/cure-md"
                className={
                  location.pathname === "/cure-md"
                    ? "active-link"
                    : ""
                }
              >
                <i className="fa fa-angle-right"></i> CureMD
              </Link>
            </li>
            <li>
              <Link
                to="/medisoft"
                className={
                  location.pathname === "/medisoft"
                    ? "active-link"
                    : ""
                }
              >
                <i className="fa fa-angle-right"></i> Medisoft
              </Link>
            </li>
            <li className={isOpen ? "open" : ""}>
              <button onClick={() => setIsOpen(!isOpen)} className="sidebar-btn" style={{ "background": "transparent", "border": "none"}}>
                <i className={`fa ${isOpen ? "fa-angle-down" : "fa-angle-right"}`}></i> Athena
              </button>

              {/* Nested Child Items (visible when isOpen is true) */}
              {isOpen && (
                <ul className="submenu">
                  <li>
                    <Link to="/medware" className={location.pathname === "/medware" ? "active-link" : ""}>
                      <i className="fa fa-circle"></i> CCD
                    </Link>
                  </li>
                  {/* <li>
                    <Link to="/other-section">
                      <i className="fa fa-circle"></i> Other Section
                    </Link>
                  </li> */}
                </ul>
              )}
            </li>
          </ul>

          <ul>
            <li className="sidebar-heading">
              <img src={FhirImage} alt="FHIR configuration" /> Masters
            </li>
            <li>
              <Link
                to="/template"
                className={
                  location.pathname === "/template"
                    ? "active-link"
                    : ""
                }
              >
                <i className="fa fa-angle-right"></i> EHR Template
              </Link>
            </li>
            <li>
              <Link
                to="/data-migration"
                className={
                  location.pathname === "/#"
                    ? "active-link"
                    : ""
                }
              >
                <i className="fa fa-angle-right"></i> Data Type Masters
              </Link>
            </li>
            <li>
              <Link
                to="/data-migration"
                className={
                  location.pathname === "/#" 
                    ? "active-link"
                    : ""
                }
              >
                <i className="fa fa-angle-right"></i> Data Format Masters
              </Link>
            </li>
            <li>
              <Link
                to="/data-migration"
                className={
                  location.pathname === "/#"
                    ? "active-link"
                    : ""
                }
              >
                <i className="fa fa-angle-right"></i> Field Mapping Masters
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
